// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1o2NZ","messages":"Chat_messages__31O2G","dateDivider":"Chat_dateDivider__SLYr8"};